import Tool, { type IToolActionInput, type IToolEnabledInput } from './Tool';
import { fabric } from 'fabric';
import Shortcut from '../utils/Shortcut';
import SimpleSelection from '../fabric/SimpleSelection';
import type Canvas from '../objects/Canvas';

class ToolSelectAll extends Tool {
  static toolName = 'Select all objects';
  static shortcut = new Shortcut('Cmd+A');

  static setSelection(canvas: Canvas, objects: fabric.Object[]) {
    if (objects.length === 1) {
      canvas.setActiveObject(objects[0]);
    } else if (objects.length > 1) {
      // @ts-expect-error these are the same (see overrides.ts) but importing SimpleSelection here
      // causes a circular import due to ShapeBases' static methods (e.g. rotateControl)
      const Cls = fabric.ActiveSelection as typeof SimpleSelection;

      const sel = new Cls(objects, {
        canvas,
      });
      canvas.setActiveObject(sel);
    }
    canvas.requestRenderAll();
  }

  static action({ controller }: IToolActionInput) {
    const canvas = controller.canvas;

    canvas.discardActiveObject();

    const canvasObjects = SimpleSelection.getFilteredObjectsForSelection(
      canvas.getObjects()
    );
    this.setSelection(canvas, canvasObjects);
  }

  static enabled({ controller }: IToolEnabledInput) {
    return !!controller.props.allowUpdate;
  }
}

export default ToolSelectAll;
